import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";
import { HOME } from "@/constants/testIds";

export default function ScrollTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!show) return null;

  return (
    <button
      data-testid={HOME.topButton}
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="Scroll to top"
      className="fixed bottom-28 right-8 z-40 w-11 h-11 rounded-full bg-cocoa-900 text-parchment-100 hover:bg-terracotta border border-parchment-100/20 flex items-center justify-center shadow-xl transition-colors"
    >
      <ArrowUp size={18} strokeWidth={1.6} />
    </button>
  );
}
